import hyperdom from 'hyperdom'
import BasePaymentMethod from './basePaymentMethod.jsx'
import formatDate from 'root-packages/dates/formatDate.js'
import formats from 'root-packages/dates/formats.js'

export default class OnHold extends BasePaymentMethod{
  constructor (payment) {
    super(payment)
  }

  render () {
  }

  book () {
    return this.payment.booking.placeBookingOnHold()
  }

  isPlacedOnHold () {
    this.payment.isPlacedOnHold = true
  }

  renderPaymentSummary () {
    return <div class='payment-summary__container onhold'>
      <div class='payment-summary__cta'>
        <p className='final-payment-summary__headline'>You are placing this booking on hold</p>
        <button type='submit' className='btn-primary hold-booking-btn' onclick={() => this.isPlacedOnHold()} >'Hold Booking'</button>
      </div>
      <ul class='payment-summary__checklist'>
        <li>Pay the rest <strong>up to {formatDate(this.payment.paymentOptions.selected.onHoldDueDateDiscounts(), formats.humanDayMonthYear)}</strong></li>
        <li>Keep booking <strong>FREE of charge</strong></li>
      </ul>

    </div>
  }
}
